import React from "react";
import { Table } from "antd";
import I18n from "../../i18n";
import store from "../../reducers/";
import moment from "moment";
import { Modal } from "antd";

const logDataSource = [{
	key: "1",
	message: "Add new User",
	created: "14/01/2018",
	causer: "Admin"
}, {
	key: "2",
	message: "Add new User",
	created: "14/01/2018",
	causer: "Admin"
}, {
	key: "3",
	message: "Add new User",
	created: "14/01/2018",
	causer: "Admin"
}, {
	key: "4",
	message: "Add new User",
	created: "14/01/2018",
	causer: "Admin"
}];

const buildColumns = (color) => {
	return [{
		title: <div style={{ color }}>{I18n.t("activity_log.titles.activity")}</div>,
		dataIndex: "message",
		render: (text) => <div style={{ wordBreak: "break-word" }}>{text}</div>,
		width: 280,
		key: "message",
	}, {
		title: <div style={{ color }}>{I18n.t("activity_log.titles.date")}</div>,
		dataIndex: "created",
		render: (text) => <div>{moment.unix(text).format("DD/MM/YYYY HH:mm")}</div>,
		key: "created",
	}, {
		title: <div style={{ color }}>{I18n.t("activity_log.titles.by")}</div>,
		dataIndex: "causer",
		key: "causer",
	}];
};

const LogsTable = ({ r, dataSource }) => {
	const { color } = store.getState().organization.organization;
	return (
		<Table
			title={() => r ? I18n.t("activity_log.header") : null}
			footer={() => r ? <a onClick={() => r.showModal()}
				style={{ textAlign: "center", color }}>{I18n.t("load_more")}</a> : null}
			dataSource={dataSource.length > 4 && r ? dataSource.slice(0, 4) : dataSource}
			columns={buildColumns(color)}
			size="small"
			pagination={!r} />
	);
};

class ModalActivityLog extends React.Component {
    state = { visible: false }
    showModal = () => {
    	this.setState({
    		visible: true,
    	});
    }
    handleOk = (e) => {
    	this.setState({
    		visible: false,
    	});
    }
    handleCancel = (e) => {
    	this.setState({
    		visible: false,
    	});
    }
    render() {
    	const { dataSource } = this.props;
    	return (
    		<Modal
    			title="Activity Logs"
    			visible={this.state.visible}
    			onOk={this.handleOk}
    			onCancel={this.handleCancel}
    			width="800px"
    			footer={null}
    		>
    			<LogsTable dataSource={dataSource} />
    		</Modal>
    	);
    }
}

class ActivityLog extends React.Component {
	render() {
		const { dataSource = logDataSource } = this.props;
		return (
			<div>
				<LogsTable r={this.refs.modal} dataSource={dataSource} />
				<ModalActivityLog ref='modal' dataSource={dataSource} />
			</div>
		);
	}
}

export default ActivityLog;


// WEBPACK FOOTER //
// ./src/components/home/ActivityLog.js